import angular from 'angular';
import uiRouter from 'angular-ui-router';
import homeComponent from './home.component';
import modals from './modals/modals';
import onboarding from './onboarding/onboarding';
import settings from './settings/settings';
import main from './main/main';


let homeModule = angular.module('home', [
    uiRouter,
    modals,
    onboarding,
    settings,
    main
  ])


  .config(($stateProvider, $urlRouterProvider) => {
    "ngInject";

    $urlRouterProvider.otherwise('/');

    $stateProvider
      .state('home', {
        url: '/home',
        component: 'home',
        redirectTo: 'home.main',
        resolve: {
          "currentAuth": (Auth) => {
            "ngInject";
            return Auth.$requireSignIn();
          },
          onboarding: (Auth, User, $state) => {
            return Auth.$requireSignIn().then(() => {
              User.getUserOnboarding().$loaded().then((onboarding) => {
                if (!onboarding.payment) {
                  return $state.go('onboarding.plans');
                }
                if (!onboarding.helpscout) {
                  return $state.go('onboarding.helpscout');
                }
                if (!onboarding.facebook) {
                  return $state.go('onboarding.facebook');
                }
                if (!onboarding.twitter) {
                  return $state.go('onboarding.twitter');
                }
                return true;
              });
            });
          }
        }
      })
      .state('home.main', {
        url: '/m',
        component: 'main'
      })
      .state('home.settings', {
        url: '/settings',
        component: 'settings'
      })
      .state('onboarding', {
        url: '/onboarding',
        component: 'onboarding',
        resolve: {
          "currentAuth": (Auth) => {
            "ngInject";
            return Auth.$requireSignIn();
          }
        }
      })
      .state('onboarding.payment', {
        url: '/payment/{planId}',
        component: 'payment',
        resolve: {
          onboarding: (User, $state) => {
            return User.getUserOnboarding().$loaded().then((onboarding) => {
              if (!onboarding.payment) {
                return true;
              }
              return $state.go('onboarding.helpscout');
            })
          }
        }
      })
      .state('onboarding.plans', {
        url: '/plans',
        component: 'plans'
      })
      .state('onboarding.helpscout', {
        url: '/helpscout',
        component: 'helpscout',
        resolve: {
          onboarding: (User, $state) => {
            return User.getUserOnboarding().$loaded().then((onboarding) => {
              if (!onboarding.helpscout) {
                return true;
              }
              return $state.go('onboarding.facebook');
            })
          }
        }
      })
      .state('onboarding.twitter', {
        url: '/twitter',
        component: 'twitter',
        resolve: {
          onboarding: (User, $state) => {
            return User.getUserOnboarding().$loaded().then((onboarding) => {
              if (!onboarding.twitter) {
                return true;
              }
              return $state.go('home');
            })
          }
        }
      })
      .state('onboarding.facebook', {
        url: '/facebook',
        component: 'facebook',
        resolve: {
          onboarding: (User, $state) => {
            return User.getUserOnboarding().$loaded().then((onboarding) => {
              if (!onboarding.facebook) {
                return true;
              }
              return $state.go('onboarding.twitter');
            })
          }
        }
      })
  })

  .component('home', homeComponent)
  .name;

export default homeModule;



// WEBPACK FOOTER //
// ./client/app/components/home/home.js